import { graphql } from "@/gql";

export const isServiceCenterPickupQuery = graphql(`
  query IsServiceCenterPickup(
    $supplierId: ID!
    $lat: Float!
    $lng: Float!
    $placeTypes: [String!]!
    $primaryType: String
  ) {
    isServiceCenterPickup(
      supplier_id: $supplierId
      lat: $lat
      lng: $lng
      place_types: $placeTypes
      primary_type: $primaryType
    )
  }
`);
